<template>
  <div class="hold">
    <h3 class="title">
      Bank Account Verification.
      <svg v-if="$auth.user().progress.account" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 352.62 352.62" style="enable-background:new 0 0 352.62 352.62;" xml:space="preserve"><g><g><path d="M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#639440"/></g></g></svg>
    </h3>
    <div class="panel-body elevated py-6">
      <div class="row" style="margin: 0;">
        <div class="col-12">
          <div class="form-group">
            <label>Your Account Number</label>
            <input  type="text" v-validate="'required'" v-model="account" placeholder="Account Number" :class="{'form-control': true, 'is-invalid': hasError && error.type === 'account'}">
            <span class="success-text" v-if="account_name">{{ account_name }}</span>
            <span class="error-text" v-if="hasError && error.type === 'account'">{{error.message}}</span>
          </div>
          <div class="form-group">
            <label for="">Choose your Bank</label>
            <select v-model="bank" class="form-control">
              <option value="" selected disabled>Choose your bank</option>
              <option value="044">Access Bank</option>
              <option value="035A">ALAT by WEMA</option>
              <option value="023">Citibank Nigeria</option>
              <option value="063">Diamond Bank</option>
              <option value="050">Ecobank Nigeria</option>
              <option value="084">Enterprise Bank</option>
              <option value="070">Fidelity Bank</option>
              <option value="011">First Bank of Nigeria</option>
              <option value="214">First City Monument Bank</option>
              <option value="058">Guaranty Trust Bank</option>
              <option value="030">Heritage Bank</option>
              <option value="301">Jaiz Bank</option>
              <option value="082">Keystone Bank</option>
              <option value="014">MainStreet Bank</option>
              <option value="526">Parallex Bank</option>
              <option value="101">Providus Bank</option>
              <option value="076">Skye Bank</option>
              <option value="221">Stanbic IBTC Bank</option>
              <option value="068">Standard Chartered Bank</option>
              <option value="232">Sterling Bank</option>
              <option value="100">Suntrust Bank</option>
              <option value="032">Union Bank of Nigeria</option>
              <option value="033">United Bank For Africa</option>
              <option value="215">Unity Bank</option>
              <option value="035">Wema Bank</option>
              <option value="057">Zenith Bank</option>
            </select>
          </div>
          <div class="row">
            <div class="col-12 mt-3 form-group">
              <button class="btn btn-success submit-button mx ignore right" :disabled="submitting || (hasError && error.type === 'account')" @click="submitAccount">Submit<i class="fa fa-spin fa-circle-o-notch" v-if="submitting"></i></button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import Spinner from '@/components/Preloaders/Spinner';

export default {
  name: 'account-verification',
  components: { Spinner },
  data() {
    return {
      hasError: false,
      account: this.$auth.user().account_details && this.$auth.user().account_details.number || '',
      bvn: this.$auth.user().account_details 
           && this.$auth.user().account_details.bvn
           && this.$auth.user().account_details.bvn.bvn || '',
      bank: this.$auth.user().account_details && this.$auth.user().account_details.bank_code ||'',
      error: {},
      submitting: false,
    };
  },
  computed: {
    account_name() {
      return this.$auth.user().account_details &&
             this.$auth.user().account_details.account_name || '';
    },
    bvn_name() {
      return this.$auth.user().account_details &&
             this.$auth.user().account_details.bvn_name || '';
    },
  },
  methods: {
    async shouldUnVerify() {
      if (this.$auth.user().verified) {
        const proceed = await swal({
          title: 'Are you Sure?',
          text: 'Please note that this action would unverify you, and you\'ll have to wait to be re-verified.',
          icon: 'warning',
          buttons: ['Don\'t bother', 'Continue >>>'],
        });
        return proceed;
      } else {
        return true;
      }
    },
    async submitAccount() {
      if (this.account === '') {
        return swal('Please fill in your account number');
      }

      if (this.bank === '') {
        return swal('Please select a bank.');
      }

      // const canProceed = await this.shouldUnVerify();

      // if (! canProceed) {
      //   return null;
      // }

      this.submitting = true;
      return axios.post(`${BASE_API}/v1/tutor/bank-account`, { account_number: this.account, bank_code: this.bank, bvn: this.bvn })
        .then(({ data }) => {
          this.$auth.fetch();
          this.submitting = false;
          this.hasError = false;
          if (data.flagged) {
            this.hasError = true;
            this.error = {
              type: 'account',
              message: 'This account is already associated with another account.',
            };
          }
        })
        .catch(({ response }) => {
          this.hasError = true;
          this.submitting = false;
          this.error = response.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.hold {
  margin: 15px 0;
}
.panel-body {
  padding: 10px !important;
}
.elevated {
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(150,150,150,0.14), 0 3px 1px -2px rgba(150,150,150,0.12), 0 1px 5px 0 rgba(150,150,150,0.2);
}
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  // float: right;
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.error-text {
  font-size: 11px;
  color: #FE595F;
  margin-left: 5px;
}
.success-text {
  font-size: 11px;
  color: #639440;
  margin-left: 5px;
}
.title {
  svg {
    float: right;
    height: 18px;
    width: 18px;
    margin: 0 15px;
  }
}
.bold {font-weight: 600; margin: 10px 0;}
.py-6 {padding: 35px 0 !important;}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Verification/Account.vue